<div
  class="avatar-container"
  [class]="'avatar-' + size()"
  [style.background-color]="backgroundColor()"
  data-toggle="tooltip"
  data-placement="auto top"
  [title]="name()"
>
  <span>
    {{ name() | avatarShortName }}
  </span>
</div>
